import { render } from "./Icon.vue?vue&type=template&id=4c1cad2b&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=4c1cad2b&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/www/grand-place-des-guinzes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1cad2b"]])

export default __exports__